import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Ko je prost dan zaposlen",
  "description": "",
  "published": "2006-04-27T00:00:00.000Z",
  "redirect_from": ["/blog/ko-je-prost-dan-zaposlen/swizec/425"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Danes je bil prvi dan v seriji 6ih uradno prostih dni, zaporedja praznikov, ki nikogar pravzaprav ne zanimajo. Vse se vrti le okoli tega, da ni pouka, sluzb in podobnega, vendar pa je vsega skupaj pravzaprav le en ubogi dan pocitnic, vse ostalo so prazniki, ko teh stvari tako-ali-tako ni.`}</p>
    <p>{`Vendar pa danasnji dan vseeno ni bil prost in brez obligacij, saj sem pogumno sel na pomoc bivsemu sosolcu pri izdelavi seminarske naloge za maturo, da bi clovek dobil dobro oceno in podobne reci. Po deseturnem garanju se je uspelo spisati nekaj spodobnega in dolgega kar 17 strani, vendar pa to naj sploh ne bi bilo veliko. Stvar je prav strasna in me ustrahuje, da se bojim naslednjega leta, ko isto doleti tudi mene in se bo potrebno podajati v te vode za samega sebe... to je bil le nekaksen pripravljalni boj.`}</p>
    <p>{`Tudi danes, v bistvu bol danasnji vecer, sem gledal film `}<a parentName="p" {...{
        "href": "http://www.imdb.com/title/tt0349683/"
      }}>{`Kralj Artur (King Arthur)`}</a>{`, ki je zelo odlicen film. Super rezija in izjemna zgodba z ravno pravim kanckom dobre stare zgodbe or Kralju Arturju in vitezih Okrogle mize. Tu je zgodba seveda sla malo drugac, naj bi bilo po bolj resnicnih zgodovinskih zapisih, a kdo bi vedel, vazno, da je zgodba super.`}</p>
    <p><img parentName="p" {...{
        "src": "https://www.rapper.it/King%20Arthur-Guinevere.jpg",
        "alt": null
      }}></img></p>
    <p>{`V drugih novicah, pred nekaj dnevi mi je uspelo zrisati prvo zamenjavo stripa, ki bo zapolnjevala prostor dokler se ne naredi prvi strip, ki bo po nacrtih izdan nekje v prvem tednu maja. Pasic mi nekako ni uspelo narediti, ker se je izkazalo, da je izdelava pasice s katero bi bil clovek zadovoljen veliko tezja, kot pa se kaze na prvi pogled. Upam torej, da se bo dalo kaj narediti do konca praznikov.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      